import { Instagram } from "lucide-react";
import { externalLinkClickHandler } from "../../lib/openExternal";
import { sizedImage } from "../../lib/imageUrl";

/**
 * CreatorHeader — the avatar + name + IG handle + count pills row used
 * on the legacy fallback layout of /u/:slug (when the creator hasn't
 * customised their hub via blocks).
 */
export function CreatorHeader({ creator, counts, hasAnything, igHandle, trackClick }) {
  return (
    <header className="text-center mb-8 sm:mb-10" data-testid="creator-directory-header">
      {creator.picture ? (
        <img
          src={sizedImage(creator.picture, 320)}
          alt=""
          className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
          style={{ border: "1px solid var(--ux-border)", boxShadow: "var(--ux-shadow-1)" }}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      ) : (
        <div
          className="w-24 h-24 rounded-full mx-auto mb-4 bg-coral flex items-center justify-center text-white font-display font-black text-4xl"
          style={{ border: "1px solid var(--ux-border)", boxShadow: "var(--ux-shadow-1)" }}
        >
          {(creator.name || creator.slug || "?").charAt(0).toUpperCase()}
        </div>
      )}
      <h1
        className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight"
        data-testid="creator-directory-name"
      >
        {creator.name || `@${creator.slug}`}
      </h1>
      {igHandle && (
        <a
          href={`https://instagram.com/${igHandle}`}
          target="_blank"
          rel="noreferrer"
          onClick={externalLinkClickHandler(
            `https://instagram.com/${igHandle}`,
            () => trackClick("ig", igHandle, `https://instagram.com/${igHandle}`),
          )}
          className="inline-flex items-center gap-1 text-sm mt-2 hover:underline"
          style={{ color: "var(--ux-ink-2)" }}
          data-testid="creator-directory-ig-link"
        >
          <Instagram className="w-4 h-4" /> @{igHandle}
        </a>
      )}
      {hasAnything && (
        <div className="flex items-center justify-center gap-2 mt-4 flex-wrap text-[11px] font-semibold uppercase tracking-wide">
          {counts.pages > 0 && (
            <span
              className="rounded-full px-2.5 py-0.5"
              style={{
                background: "color-mix(in srgb, var(--ux-mint) 45%, white)",
                border: "1px solid var(--ux-border)",
                color: "var(--ux-ink)",
              }}
            >
              {counts.pages} page{counts.pages !== 1 ? "s" : ""}
            </span>
          )}
          {counts.products > 0 && (
            <span
              className="rounded-full px-2.5 py-0.5"
              style={{
                background: "color-mix(in srgb, var(--ux-sun) 45%, white)",
                border: "1px solid var(--ux-border)",
                color: "var(--ux-ink)",
              }}
            >
              {counts.products} product{counts.products !== 1 ? "s" : ""}
            </span>
          )}
          {counts.coupons > 0 && (
            <span
              className="rounded-full px-2.5 py-0.5 text-white"
              style={{ background: "var(--ux-coral)", border: "1px solid var(--ux-coral)" }}
            >
              {counts.coupons} deal{counts.coupons !== 1 ? "s" : ""}
            </span>
          )}
        </div>
      )}
    </header>
  );
}
